module.exports = flarum.core.compat['components/Tooltip'];